// extracted by mini-css-extract-plugin
export var md = "_5s-4";
export var semantic = "_5s-5";
export var sm = "_5s-3";
export var text = "_5s-6";
export var toggleInput = "_5s-0";
export var toggleSwitch = "_5s-1";
export var xs = "_5s-2";